import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Routes, Route } from "react-router-dom";
import { Outlet, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
// components
import Sidebar from "../components/Sidebar/Sidebar.jsx";
import MobilePage from "../components/Sidebar/MobilePageTitle.jsx";
import AdminNavbar from "../components/Navbar/AdminNavbar";
import { masterLogout, reset } from '../features/masterAuth/masterAuthSlice.js';
import ErrorBoundary from '../components/ErrorBoundary';

export default function Admin() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const headerText = useSelector(
    (state) =>
      state.headerText.headerTextState &&
      state.headerText.headerTextState    //toLowerCase()
  );

  const sideBarText = useSelector(
    (state) => state.sideBarText.sideBarTextState
  );
  const { appSettings } = useSelector((state) => state.appSettings);
  const timerData = useSelector((state) => state.timerData.timerDataState);
  var start = localStorage?.getItem("startTime") !== "undefined" ? JSON.parse(localStorage?.getItem("startTime")) : null;
  var isRunning = localStorage?.getItem("startTime") !== "undefined" ? JSON.parse(localStorage?.getItem("isRunning")) : null;
  useEffect(() => {
    localStorage.removeItem("masterUser");
    dispatch(reset());
    let token = null;
    const user = localStorage.getItem("user");
    if (user) {
      const parsedUser = JSON.parse(user);
      if (parsedUser && parsedUser.token) {
        token = parsedUser.token;
      }
    }

    if (!token) {
      navigate("/");
    }
  }, []);
  const isClientPage = () => {
    return window.location.pathname.startsWith("/client");
  };
  const isVendorPage = () => {
    return window.location.pathname.startsWith("/vendor");
  };
  const isUserDetailsPage = () => {
    return window.location.pathname.startsWith("/user/profile");
  };
  const isUserRegisterPage = () => {
    return window.location.pathname.startsWith("/user/register");
  };
  const isInvoiceSinglePage = () => {
    return window.location.pathname.startsWith("/user/invoice/view");
  };
  const isInvoiceCreatePage = () => {
    const path = location.pathname;
    return (
      path.startsWith("/user/invoice/manual/create") ||
      path.startsWith("/user/invoice/auto/create")
    );
  };
  const isTimeOffCreatePage = () => {
    return location.pathname.startsWith("/user/time-off/create");
  };
  const isExpensePage = () => {
    return window.location.pathname.startsWith("/user/expense/view");
  };
  const isCreateInvoice = isInvoiceCreatePage();
  const [isMobileViewport, setIsMobileViewport] = useState(() =>
    typeof window !== "undefined" && window.matchMedia("(max-width: 991px)").matches
  );

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 991px)");
    const onChange = (event) => setIsMobileViewport(event.matches);
    setIsMobileViewport(mq.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  // Hide sidebar only on mobile create-invoice; keep classic desktop layout with sidebar
  const hideSidebar = isCreateInvoice && isMobileViewport;
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(() => {
    const collapsed = localStorage.getItem('sidebarCollapsed') === 'true';
    document.body.classList.toggle('sidebar-collapsed', collapsed);
    return collapsed;
  });

  const handleSidebarCollapse = (collapsed) => {
    setIsSidebarCollapsed(collapsed);
    localStorage.setItem('sidebarCollapsed', collapsed);
    document.body.classList.toggle('sidebar-collapsed', collapsed);
  };

  const handleCloseSideBar = () => {

  };
  useEffect(() => {
    let intervalId;

    const updateTitleAndTimer = () => {
      const runningTime = moment().diff(moment(start), "seconds");
      const hours = Math.floor(runningTime / 3600);
      const minutes = Math.floor((runningTime % 3600) / 60);
      const seconds = runningTime % 60;

      const formattedHours = String(hours).padStart(2, "0");
      const formattedMinutes = String(minutes).padStart(2, "0");
      const formattedSeconds = String(seconds).padStart(2, "0");

      document.title = `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
    };

    if (isRunning) {
      // Update title immediately
      updateTitleAndTimer();
      // Set interval to update more frequently (e.g., every 100 milliseconds)
      intervalId = setInterval(updateTitleAndTimer, 100);
    } else {
      document.title = "Talenton";
    }

    // Cleanup the interval when component unmounts or when timer is stopped
    return () => clearInterval(intervalId);
  }, [isRunning, start, timerData]);

  return (
    <div className={`admin-outer ${headerText}${hideSidebar ? " hide-sidebar" : ""}`}>
      <div className={`admin-inner${isSidebarCollapsed ? ' sidebar-collapsed' : ''}${hideSidebar ? ' hide-sidebar' : ''}`}>
        {!hideSidebar && (
          <div className="sidebar-nav">
            <Sidebar onCancel={handleCloseSideBar} isCollapsed={isSidebarCollapsed} onCollapseChange={handleSidebarCollapse} />
            <button
              className="sidebar-collapse-btn"
              onClick={() => handleSidebarCollapse(!isSidebarCollapsed)}
              title={isSidebarCollapsed ? 'Expand menu' : 'Collapse menu'}
            >
              <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ transform: isSidebarCollapsed ? 'rotate(0deg)' : 'rotate(180deg)', transition: 'transform 0.3s ease' }}>
                <path d="M1 1L7 7L1 13" stroke="#405bff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </div>
        )}
        <div className="outer-nav">
          <AdminNavbar />
          <div className="page-top-section-header">
            <div className="page-top-section-left">
              <div className="inner-page-head">
                <MobilePage />
              </div>
            </div>
            <div className="page-top-section-right">
              <div className='comapany-name-mobile'>{appSettings && appSettings.app_ownername ? appSettings.app_ownername : "TalentOn"}</div>
            </div>
          </div>
          <div id="content-modal-root" className="content-modal-root">
            <div className={`content-outer ${headerText} ${isVendorPage() ? "vendors" : ""}${isClientPage() ? "clients" : ""}${isExpensePage() ? "expense" : ""}${isUserDetailsPage() ? "user details" : ""}${isUserRegisterPage() ? "user register" : ""}${isInvoiceSinglePage() ? "invoice-single" : ""}${isCreateInvoice ? " invoice-create" : ""}${isTimeOffCreatePage() ? " time-off-create" : ""}`} >
              <div className="content-inner">
                <ErrorBoundary key={location.pathname}>
                  <Outlet />
                </ErrorBoundary>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
